// extracted by mini-css-extract-plugin
module.exports = {"footer":"SetRequestNftPriceModal_footer__3mfsZ","label":"SetRequestNftPriceModal_label__3Z7SQ","error":"SetRequestNftPriceModal_error__2Osiq"};